import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import classNames from 'classnames';
import { de } from 'date-fns/locale';
import { format } from 'date-fns';
import { FormattedMessage, injectIntl } from 'react-intl';
import Tooltip from 'rc-tooltip';

import { RootState } from '../../../reducers';
import * as actions from '../../../actions/index';
import * as _actionsSujet from '../../../actions/sujet';
import * as _actionsJourney from '../../../actions/journey1';
import * as _actionsJourney2 from '../../../actions/journey2';
import * as _actionsProduct from '../../../actions/product';
import * as _actionsCheckout from '../../../actions/checkout';
import * as _actionsBasket from '../../../actions/basket';
import { Button, EButtonType } from '@repo/apg-ui';
import styles from '../../../components/CampaignDetailRow/CampaignDetailRow.module.scss';
import BreadCrumbs from '../../../components/BreadCrumbs';
import CamapignDetailRow from '../../../components/CampaignDetailRow';
import Spinner from '../../../components/Spinner';
import SpinnerV2 from '../../../components/SpinnerV2';
import './CampaignDetail.scss';
import ErrorContainer from '../../../components/ErrorContainer/ErrorContainer';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';
import { ReactComponent as RedEye } from '../../../assets/icons/red_eye.svg';
import { ReactComponent as GreenEye } from '../../../assets/icons/greenEye.svg';
import { ReactComponent as RedX } from '../../../assets/icons/redX.svg';
import { ReactComponent as RedPlus } from '../../../assets/icons/redPlus.svg';
import { ReactComponent as BuyIcon } from '../../../assets/icons/buy.svg';
// import { ReactComponent as GoTo } from '../../../assets/icons/goTo.svg';
import { ReactComponent as ArrowTopLong } from '../../../assets/icons/arrow_long.svg';
import { ReactComponent as UploadIcon } from '../../../assets/icons/e_i_upload.svg';
import config, { isProd, isStage } from '../../../constants/config';
import isValid from 'date-fns/esm/fp/isValid/index.js';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { ModalContainer } from '../../../components/ModalContainer';
import ProductsTable from '../../../components/ProductsTable';
import { SchemaProduct } from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsJourney: typeof _actionsJourney;
  actionsJourney2: typeof _actionsJourney2;
  actionsBasket: typeof _actionsBasket;
  actionsCheckout: typeof _actionsCheckout;
  actionsSujet: typeof _actionsSujet;
  baskets: any;
  campaignDetails: any;
  history: any;
  intl: any;
  keycloakReady: any;
  locales: any;
  location: any;
  match: any;
  proposalsObj: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  isOfferte: boolean;
  productsJ2ByUrn: Record<string, SchemaProduct>;
  errors: any;
  product: any;
  productsJ2: SchemaProduct[];
  loading: any;
  actionsProduct: typeof _actionsProduct;
}

type ConfirmationModalType = 'buchen' | 'bearbeiten' | 'löschen';

const CampaignDetail = (props: Props) => {
  const [basketCategory, setBasketCategory] = React.useState(1);
  const [basketId, setBasketId] = React.useState(null);
  const [basketReference, setBasketReference] = React.useState(null);
  const [isBookingLoading, setIsBookingLoading] = React.useState(false);
  const [confirmationModalType, setConfirmationModalType] = React.useState<ConfirmationModalType>('buchen');

  const params = useParams();
  const navigate = useNavigate();
  const campaignId = params.campaignId;

  const { history, intl, isOfferte } = props;

  // const modalContent = getParameterByName('modalContent', location.search);

  useEffect(() => {
    if (props.keycloakReady) {
      props.actionsSujet.getCampaignDetails({ number: campaignId }).then((res) => {
        props.actionsBasket
          .fetchBasketInfo(
            {
              basket: res?.campaigndata?.basketid,
            },
            null,
            true,
          )
          .then((res) => {
            setBasketCategory(res.category);
            setBasketId(res.basket);
            setBasketReference(res.basketreference);
          });
      });
    }
  }, []);

  const getCreationOrderButtons = (campaignObj) => {
    const campaignData = campaignObj.campaigndata;

    const buttons = [];
    if (campaignData.creationorder == -1) {
      buttons.push(null);
    } else if (campaignData.creationorder == 0) {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3`, { active: false })}
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            navigate(
              campaignData.type === 'digital'
                ? `/campaign/${campaignData.number}/creation-order-new-digital`
                : `/campaign/${campaignData.number}/creation-order-new`,
            );
          }}
        >
          <RedPlus />
        </Button>,
      );
    } else if (campaignData.creationorder == '-2') {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3`, { active: false })}
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            navigate(`/campaign/${campaignData.number}/production-order-railposters`);
          }}
        >
          <RedPlus />
        </Button>,
      );
    } else {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3`, { active: false })}
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            navigate(
              campaignData.type === 'digital'
                ? `/campaign/${campaignData.number}/creation-order-digital/${campaignData.creationorder}`
                : `/campaign/${campaignData.number}/creation-order/${campaignData.creationorder}`,
            );
          }}
        >
          <GreenEye />
        </Button>,
      );
    }

    const url = isProd
      ? props.intl.formatMessage({
          id: 'ec.campaignRow.designTemplatesProdLink',
          defaultMessage: 'https://apgsga.ch/de/vorlagen-und-spezifikationen/',
        })
      : isStage
        ? props.intl.formatMessage({
            id: 'ec.campaignRow.designTemplatesStageLink',
            defaultMessage:
              'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/vorlagen-und-spezifikationen/',
          })
        : props.intl.formatMessage({
            id: 'ec.campaignRow.designTemplatesDevLink',
            defaultMessage:
              'https://apgwebsite2021privatecloud-dev-8fd10b4.apg.divio.cloud/de/vorlagen-und-spezifikationen/',
          });

    buttons.push(
      <Button
        className={classNames(`${styles.productRowButton} me-3`, { active: false })}
        buttonType={EButtonType.BasicLink}
        href={url}
      >
        <BuyIcon />
      </Button>,
    );
    return buttons;
  };

  const getProductionOrderButtons = (campaignObj) => {
    const buttons = [];
    const campaignData = campaignObj.campaigndata;

    if (campaignData.productionorder == -1) {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3 mt-2`, { active: false })}
          buttonType={EButtonType.BasicLink}
          isDisabled={true}
        >
          <RedX className='red-x-icon' />
        </Button>,
      );
    } else if (campaignData.productionorder == 0) {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3`, { active: false })}
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            navigate(`/campaign/${campaignData.number}/production-order-new`);
          }}
        >
          <RedPlus />
        </Button>,
      );
    } else if (campaignData.productionorder == '-2') {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3`, { active: false })}
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            navigate(`/campaign/${campaignData.number}/production-order-railposters`);
          }}
        >
          <RedPlus />
        </Button>,
      );
    } else {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3`, { active: false })}
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            navigate(`/campaign/${campaignData.number}/production-order/${campaignData.productionorder}`);
          }}
        >
          <GreenEye />
        </Button>,
      );
    }

    return buttons;
  };

  const getUploadButtons = (campaignObj) => {
    const campaignData = campaignObj.campaigndata;

    const buttons = [];
    if (campaignData.directupload == -1) {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3 mt-2`, { active: false })}
          buttonType={EButtonType.BasicLink}
          isDisabled
        >
          <RedX className='red-x-icon' />
        </Button>,
      );
    } else if (campaignData.directupload == 0) {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3 mt-2`, { active: false })}
          buttonType={EButtonType.BasicLink}
          isDisabled
        >
          <RedX className='red-x-icon' />
        </Button>,
      );
    } else {
      buttons.push(
        <Button
          className={classNames(`${styles.productRowButton} me-3`, { active: false })}
          buttonType={EButtonType.BasicLink}
          href={campaignData.directupload}
        >
          <UploadIcon className='upload-icon' />
        </Button>,
      );
    }

    return buttons;
  };

  const getCampaignObj = () => {
    const { campaignDetails } = props;

    return campaignDetails && campaignDetails[campaignId] ? campaignDetails[campaignId] : {};
  };

  const renderDeliveryInfo = (deliveryInfo) => {
    if (deliveryInfo && deliveryInfo.deliverydate) {
      return (
        <div className='mb-3'>
          <span className='row justify-content-start'>
            <p className='fw-bold mb-0'>
              <FormattedMessage id='as.sujet.delivery' defaultMessage='Werbemittelanlieferung:' />
            </p>
          </span>

          <span className='row justify-content-start'>
            <p className='mb-0'>
              <FormattedMessage
                id='as.sujet.deliveryDate'
                defaultMessage='Bis am {date}'
                values={{
                  date: format(Date.parse(deliveryInfo.deliverydate), 'dd-MM-yyyy', { locale: de }),
                }}
              />
            </p>
          </span>

          {deliveryInfo.type !== 'digital' && deliveryInfo.deliveryaddress && (
            <span className='row justify-content-start'>
              <p className='mb-0'>{deliveryInfo.deliveryaddress}</p>
            </span>
          )}
        </div>
      );
    }

    return null;
  };

  const renderFormatCount = () => {
    const campaignObj = getCampaignObj();
    if (campaignObj.campaigndata) {
      return (
        <div className='mb-3'>
          <span className='row justify-content-start'>
            <p className='fw-bold mb-0'>{campaignObj.campaigndata.formatlabel}</p>
          </span>

          <span className='row justify-content-start'>
            <p className='mb-0'>{campaignObj.campaigndata.countformats}</p>
          </span>
        </div>
      );
    }

    return null;
  };

  const bookCampaignOfferte = (basketId) => {
    setIsBookingLoading(true);
    props.actionsCheckout
      .getBookBasket({ basket: basketId })
      .then((res) => {
        if (res && res.data) {
          if (res.data.campaign) {
            props.actionsBasket
              .fetchBasketInfo({
                basket: basketId,
              })
              .then(() => {
                navigate({
                  pathname: `/journey2/6`,
                  search: `?campaignId=${campaignId}`,
                });
              });
          }
        }
      })
      .catch((err) => {
        setIsBookingLoading(false);
      });
  };

  const rebookCampaignOfferte = () => {
    setIsBookingLoading(true);
    props.actionsBasket
      .deleteBasket({ basket: basketId })
      .then(() => {
        setIsBookingLoading(false);
        navigate({
          pathname: `/journey2/1`,
          search: `?basketId=${basketId}&basketreference=${basketReference}`,
        });
      })
      .catch((err) => {
        setIsBookingLoading(false);
      });
  };

  const deleteCampaignOfferte = () => {
    setIsBookingLoading(true);
    props.actionsBasket
      .deleteBasket({ basket: basketId })
      .then(() => {
        setIsBookingLoading(false);
        navigate({
          pathname: `/dashboard`,
        });
      })
      .catch((err) => {
        setIsBookingLoading(false);
      });
  };

  const campaignObj = getCampaignObj();

  const getConfirmationContent = () => {
    if (confirmationModalType === 'buchen') {
      return (
        <div className='m-4 pt-24 d-flex flex-column'>
          <p>
            <FormattedMessage
              id='ec.confirmation.bookCampaignConfirmation'
              defaultMessage='Wollen sie die reservierten Flächen nun endgültig kostenpflichtig buchen?'
            />
          </p>
          <p>
            <b>
              {campaignObj?.campaigndata?.number} - {campaignObj?.campaigndata?.name}
            </b>
          </p>
        </div>
      );
    } else if (confirmationModalType === 'bearbeiten') {
      return (
        <div className='m-4 pt-24 d-flex flex-column'>
          <p>
            <FormattedMessage
              id='ec.confirmation.editCampaignConfirmation'
              defaultMessage='Wollen Sie die Reservierung aufheben und an der Kampagne unten weiterarbeiten?'
            />
          </p>
          <p>
            <b>
              {campaignObj?.campaigndata?.number} - {campaignObj?.campaigndata?.name}
            </b>
          </p>
        </div>
      );
    } else if (confirmationModalType === 'löschen') {
      return (
        <div className='m-4 pt-24 d-flex flex-column'>
          <p>
            <FormattedMessage
              id='ec.confirmation.removeOfferConfirmation'
              defaultMessage='Wollen Sie die Reservierung aufheben?'
            />
          </p>
          <p>
            <b>
              {campaignObj?.campaigndata?.number} - {campaignObj?.campaigndata?.name}
            </b>
          </p>
        </div>
      );
    }
    return <></>;
  };

  const getConfirmationOnSuccess = () => {
    if (confirmationModalType === 'buchen') {
      return () => {
        bookCampaignOfferte(campaignObj.campaigndata?.basketid);
      };
    } else if (confirmationModalType === 'bearbeiten') {
      return () => {
        rebookCampaignOfferte();
      };
    } else if (confirmationModalType === 'löschen') {
      return () => {
        deleteCampaignOfferte();
      };
    }
    return () => {};
  };

  return campaignObj && Object.keys(campaignObj).length > 0 ? (
    <>
      <BreadCrumbs
        parentPage={intl.formatMessage({
          id: 'ec.navigation.dashboard',
          defaultMessage: 'Dashboard',
        })}
        pageName={campaignObj.campaigndata.name}
      />
      <div className='container-fluid journey1  overflow-hidden p-0'>
        <div className='pageContainer'>
          <ModalContainer
            userDataEC={props.userDataEC}
            loading={props.loading}
            actionsJourney2={_actionsJourney2}
            actionsBasket={_actionsBasket}
            location={props.location}
            intl={props.intl}
            productsJ2ByUrn={props.productsJ2ByUrn}
            errors={props.errors}
            product={props.product}
            actionsProduct={_actionsProduct}
            productsJ2={props.productsJ2}
            campaignObj={getCampaignObj()}
            confirmationContent={getConfirmationContent()}
            confirmationOnSuccess={getConfirmationOnSuccess()}
            isSuccessButtonLoading={isBookingLoading}
          />

          <div className='campaign-detail w-100'>
            <div className='row justify-content-between'>
              <div
                className={classNames({
                  'col-5': !isOfferte,
                  'col-12': isOfferte,
                })}
              >
                <h4 className='fw-bold mb-3 px-4 py-2 title-campagne-detail'>
                  {campaignObj && campaignObj.campaigndata.name}
                </h4>

                <div className='row justify-content-between'>
                  <div className='mb-3'>
                    <span className='row justify-content-start'>
                      <p className='fw-bold mb-0'>
                        <FormattedMessage id='as.sujet.kampagne' defaultMessage='Kampagne:' />
                      </p>

                      <p className='ms-3 mb-0'>{campaignObj && campaignObj.campaigndata.number}</p>
                    </span>

                    <span className='row justify-content-start'>
                      <p className='fw-bold mb-0'>
                        <FormattedMessage id='as.sujet.ab' defaultMessage='Ab' />:
                      </p>

                      <p className='ms-3 mb-0'>
                        {campaignObj &&
                        campaignObj.campaigndata.startdate &&
                        isValid(Date.parse(campaignObj.campaigndata.startdate))
                          ? format(Date.parse(campaignObj.campaigndata.startdate), 'dd-MM-yyyy', {
                              locale: de,
                            })
                          : campaignObj.campaigndata.startdate}
                      </p>
                    </span>

                    <span className='row justify-content-start'>
                      <p className='fw-bold mb-0'>
                        <FormattedMessage id='as.sujet.werbeform' defaultMessage='Werbeform:' />
                      </p>

                      <p className='ms-3 mb-0'>{campaignObj && campaignObj.campaigndata.formats}</p>
                    </span>
                  </div>

                  {campaignObj.campaigndata && renderDeliveryInfo(campaignObj.campaigndata)}
                  {renderFormatCount()}
                </div>
              </div>

              <div className='col-7 justify-content-end'>
                {basketCategory === 1 && !isOfferte && (
                  <div className='services-card column'>
                    <p className='services-card-title'>
                      <FormattedMessage id='as.sujet.services' defaultMessage='Services' />
                    </p>

                    <div className='row p-0'>
                      <div className='col column ps-0'>
                        <p className='fw-bold mb-0'>
                          <FormattedMessage id='as.sujet.gestaltung' defaultMessage='Gestaltung' />
                        </p>

                        <p className='service-icons'>{getCreationOrderButtons(campaignObj)}</p>
                      </div>

                      <div className='col column'>
                        <p className='fw-bold mb-0 text-center'>
                          <FormattedMessage id='as.sujet.druck' defaultMessage='Druck' />
                        </p>

                        <span className='row service-icons justify-content-center'>
                          {getProductionOrderButtons(campaignObj)}
                        </span>
                      </div>

                      <div className='col column pe-0'>
                        <p className='fw-bold mb-0 text-center'>
                          <FormattedMessage id='as.sujet.spotUpload' defaultMessage='Spot-Upload' />
                        </p>

                        <span className='row service-icons justify-content-center'>
                          {getUploadButtons(campaignObj)}
                        </span>
                      </div>
                    </div>

                    <div className='d-flex justify-content-end'>
                      <Button className='mt-24' onClick={() => navigate({ search: `?modalContent=legende` })}>
                        <div className='legend d-flex'>
                          <Tooltip
                            overlayClassName={'rc-tooltip-bg-white'}
                            placement={'right'}
                            overlay={
                              <b>
                                <FormattedMessage id='ec.confirmation.legendTooltip' defaultMessage='Legend tooltip' />
                              </b>
                            }
                          >
                            <InfoIcon className='me-3' />
                          </Tooltip>

                          <p className='red-text'>
                            <FormattedMessage id='ec.confirmation.legend' defaultMessage='Legende' />
                          </p>
                        </div>
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              <div className='d-flex info-buttons'>
                <span className='me-3'>
                  <Button
                    onClick={() => {
                      navigate('/dashboard');
                    }}
                    buttonType={EButtonType.InvertedPillMedium}
                  >
                    <FormattedMessage id='ec.components.buttons.dashboard' defaultMessage='Dashboard' />
                  </Button>
                </span>
                {(campaignObj?.campaigndata?.possibleactions || []).includes('copy') && (
                  <span className='me-3'>
                    <Button
                      onClick={() => {
                        navigate(`/journey3/${campaignObj.campaigndata?.basketid}/${campaignObj.campaigndata?.number}`);
                      }}
                      buttonType={EButtonType.InvertedPillMedium}
                    >
                      <FormattedMessage
                        id='ec.components.buttons.copyCampaign'
                        defaultMessage='Kampagne nochmals buchen'
                      />
                    </Button>
                  </span>
                )}
                {(campaignObj?.campaigndata?.possibleactions || []).includes('deleteedit') && (
                  <span className='me-3'>
                    <Button
                      onClick={() => {
                        setConfirmationModalType('bearbeiten');
                        navigate({ search: `?modalContent=confirmation` });
                      }}
                      buttonType={EButtonType.InvertedPillMedium}
                      isDisabled={isBookingLoading}
                    >
                      {isBookingLoading ? (
                        <Spinner relative />
                      ) : (
                        <FormattedMessage
                          id='ec.components.buttons.rebookCampaignOfferte'
                          defaultMessage='Kampagne bearbeiten'
                        />
                      )}
                    </Button>
                  </span>
                )}
                {(campaignObj?.campaigndata?.possibleactions || []).includes('book') && (
                  <span className='me-3'>
                    <Button
                      onClick={() => {
                        setConfirmationModalType('buchen');
                        navigate({ search: `?modalContent=confirmation` });
                      }}
                      buttonType={EButtonType.InvertedPillMedium}
                      isDisabled={isBookingLoading}
                    >
                      {isBookingLoading ? (
                        <Spinner relative />
                      ) : (
                        <FormattedMessage
                          id='ec.components.buttons.bookCampaignOfferte'
                          defaultMessage='Kampagne buchen'
                        />
                      )}
                    </Button>
                  </span>
                )}
                {(campaignObj?.campaigndata?.possibleactions || []).includes('book') && (
                  <span className='me-3'>
                    <Button
                      onClick={() => {
                        setConfirmationModalType('löschen');
                        navigate({ search: `?modalContent=confirmation` });
                      }}
                      buttonType={EButtonType.InvertedPillMedium}
                      isDisabled={isBookingLoading}
                    >
                      {isBookingLoading ? (
                        <Spinner relative />
                      ) : (
                        <FormattedMessage
                          id='ec.components.buttons.deleteCampaignOfferte'
                          defaultMessage='Kampagne löschen'
                        />
                      )}
                    </Button>
                  </span>
                )}
                <span className='me-3'>
                  <a
                    className='button invertedPill medium custom-link'
                    href={`${config.apiUrl}basketcontent?basket=${basketId}&basketreference=${basketReference}&state=1&limit=-1&format=agencyxls&language=${intl.locale}`}
                    target={'_blank'}
                    rel='noopener noreferrer'
                  >
                    <FormattedMessage id='ec.components.buttons.exportBasket' defaultMessage='XLSX Export' />
                  </a>
                </span>
              </div>
            </div>

            <hr className='campaign-line' />

            <ErrorContainer journeyType='afterSales' />

            <div className='row justify-content-start'>
              {campaignObj.creationorder && (
                <div className='col-4 company-detail'>
                  <h4 className='fw-bold col-12 mb-4 ps-0 title-order'>
                    <FormattedMessage id='as.sujet.gestaltungsauftrag' defaultMessage='Erteiltler Gestaltungsauftrag' />
                  </h4>

                  <p className='mb-3 text-order'>
                    <FormattedMessage id='as.sujet.am' defaultMessage='Am' />:{' '}
                    {campaignObj &&
                      format(Date.parse(campaignObj.creationorder.date), 'dd-MM-yyyy', {
                        locale: de,
                      })}
                  </p>

                  <p className='fw-bold mb-0 text-order'>{campaignObj.creationorder.company.bezeichnung}</p>

                  <p className='mb-0 text-order'>{campaignObj.creationorder.company.emaildruckerei}</p>

                  <p className='mb-0 text-order'>{campaignObj.creationorder.company.telnrdruckerei}</p>

                  <Button
                    onClick={() => {
                      navigate(
                        campaignObj.campaigndata.type === 'digital'
                          ? `/campaign/${campaignObj.campaigndata.number}/creation-order-digital/${campaignObj.creationorder.number}`
                          : `/campaign/${campaignObj.campaigndata.number}/creation-order/${campaignObj.creationorder.number}`,
                      );
                    }}
                  >
                    <span className='row mt-2 p-0 justify-content-start open-preview'>
                      <RedEye />

                      <p className='fw-bold'>
                        <FormattedMessage id='as.sujet.openPreview' defaultMessage='Vorschau öffnen' />
                      </p>
                    </span>
                  </Button>
                </div>
              )}

              {campaignObj.productionorder && (
                <div className='col-4 company-detail'>
                  <h4 className='fw-bold col-12 mb-4 ps-0 title-order'>
                    <FormattedMessage id='as.sujet.druckauftrag' defaultMessage='Druckauftrag' />
                  </h4>

                  <p className='mb-3 text-order'>
                    <FormattedMessage id='as.sujet.am' defaultMessage='Am' />:{' '}
                    {campaignObj &&
                      format(Date.parse(campaignObj.productionorder.date), 'dd-MM-yyyy', {
                        locale: de,
                      })}
                  </p>

                  <p className='fw-bold mb-0 text-order'>{campaignObj.productionorder.company.bezeichnung}</p>

                  <p className='mb-0 text-order'>{campaignObj.productionorder.company.emaildruckerei}</p>

                  <p className='mb-0 text-order'>{campaignObj.productionorder.company.telnrdruckerei}</p>

                  <Button
                    onClick={() => {
                      navigate(
                        `/campaign/${campaignObj.campaigndata.number}/production-order/${campaignObj.productionorder.number}`,
                      );
                    }}
                  >
                    <span className='row mt-2 p-0 justify-content-start open-preview'>
                      <RedEye />

                      <p className='fw-bold'>
                        <FormattedMessage id='as.sujet.openPreview' defaultMessage='Vorschau öffnen' />
                      </p>
                    </span>
                  </Button>
                </div>
              )}
            </div>

            <div className='w-100 bg-white mt-4'>
              <h4 className='fw-bold col-12 ms-4 mt-4 mb-2 title-order ps-0 pt-5'>
                <FormattedMessage id='as.sujet.gebuchteFlachen' defaultMessage='Flächen' />
              </h4>

              <div className='p-0 d-flex mx-24 flex-column mt-4 overflow-auto'>
                <div className={styles.campaignDetailHeader}>
                  <div className={styles.campaignDetailRowColumn}>
                    <p className='fw-bold text-header'>
                      <FormattedMessage id='as.sujet.id' defaultMessage='Produkt-ID' />
                    </p>
                  </div>

                  <div className={styles.campaignDetailRowColumn}>
                    <p className='fw-bold text-header'>
                      <FormattedMessage id='as.sujet.anz_formate' defaultMessage='Anz. / Formate' />
                    </p>
                  </div>

                  <div className={styles.campaignDetailRowColumn}>
                    <p className='fw-bold text-header'>
                      <FormattedMessage id='as.sujet.standort' defaultMessage='Standort' />
                    </p>
                  </div>

                  <div className={styles.campaignDetailRowColumn}>
                    <p className='fw-bold text-header'>
                      <FormattedMessage id='as.sujet.termin' defaultMessage='Zeitraum' />
                    </p>
                  </div>

                  <div className={styles.campaignDetailRowColumn}>
                    <p className='fw-bold text-header'>
                      <FormattedMessage id='as.sujet.chf' defaultMessage='CHF' />
                    </p>
                  </div>
                </div>

                {campaignObj &&
                  campaignObj.products.map((product, index) => (
                    <CamapignDetailRow
                      key={`${product.producturn}`}
                      index={index}
                      product={product}
                      history={history}
                      campaignId={campaignObj.campaigndata.number}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <SpinnerV2 />
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsSujet: bindActionCreators(_actionsSujet as any, dispatch),
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsCheckout: bindActionCreators(_actionsCheckout as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CampaignDetail)));
